import { styled } from '@mui/system'
import { TTheme } from '@/core/theme'
import { Pulsate } from '@components/skeleton-table/skeletonTable.styles'

export const CloudAppSection = styled('div')<{ theme?: TTheme }>`
    padding: 20px;
    margin-top: 24px;
    background-color: ${({ theme }) =>
        theme?.colors.semantic.backgroundSecondary || '#FFFFFF'};
    border-radius: 16px;
    border: 1px solid ${({ theme }) => theme?.colors.greys[200] || '#E6E6E6'};
    display: flex;
    flex-direction: column;
    gap: 16px;
`

export const SectionSubtitle = styled(Pulsate)`
    width: 200px;
    height: 24px;
`
